/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./table-form.vue?vue&type=template&id=1f4743a7&scoped=true&"
import script from "./table-form.vue?vue&type=script&lang=ts&"
export * from "./table-form.vue?vue&type=script&lang=ts&"
import style0 from "./table-form.vue?vue&type=style&index=0&id=1f4743a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4743a7",
  null
  
)

export default component.exports